<template>
	<div class="container-fluid px-lg-2 px-xl-4">
		<!-- Encabezado de ubicación (Breadcum)-->
		<div class="posicion-menu">
			<div class="d-none d-md-block d-lg-block d-xl-block">
				<div class="row d-flex align-items-center bg-gray">
					<div class="col-12 col-sm-7 pl-0">
						<nav aria-label="breadcrumb" style="background-color = #fff">
							<ol class="breadcrumb pl-0">
								<li class="breadcrumb-item">Captura de pedidos</li>
								<li class="breadcrumb-item">Catálogo general</li>
								<li class="breadcrumb-item" v-show="busqueda.parametros.busquedaAvanzada">Búsqueda avanzada 4</li>
							</ol>
						</nav>
					</div>
					<div class="col-12 col-sm-4 ml-auto" v-show="!busqueda.parametros.busquedaAvanzada">
						<button
							@click="mostrarBusquedaAvanzada(true)"
							class="btn btn-sm btn-blue-1 btn-block my-2 my-sm-0"
						>Búsqueda avanzada</button>
					</div>
				</div>
			</div>
			<!-- Termina Encabezado de ubicación (Breadcum) -->
			
			<!-- Barra de filtros resolución escritorio -->
			<div class="row" v-show="busqueda.resultados.resultadosPrincipales.length > 0 || busqueda.resultados.resultadosSugeridos.length > 0">
				<div class="col-12">
					<!-- <div class="row bg-white"> -->
					<div class="d-none d-md-block d-lg-block d-xl-block">
						<div class="row bg-white">
							<div class="col-1 d-block d-md-none d-flex p-1">
								<i class="icon-trazado-1107 align-self-center ml-auto" style="font-size:1.1em;"></i>
							</div>
							<div class="col-11 col-md-3 p-md-0 d-md-flex align-items-center">
								<i
									class="d-none d-md-block icon-trazado-1107 align-self-center ml-auto mr-1"
									style="font-size:1.1em;"
								></i>
								<select
									@change="ordenar"
									class="form-control form-control-sm my-1 mr-sm-2 input-select ordenar-por-select"
									v-model="busqueda.parametros.orden"
								>
									<option value="0">Orden</option>
									<option value="1">Alfabético</option>
									<option value="2">Genérico</option>
									<option value="3">Precio Ascendente</option>
									<option value="4">Precio Descendente</option>
								</select>
							</div>
							<div class="col-1 d-block d-md-none d-flex p-0 align-items-centerr">
								<i class="icon-trazado-1108 ml-auto" style="font-size:1.1em;"></i>
							</div>
							<div class="col-11 col-md-4 d-md-flex align-items-center">
								<i class="d-none d-md-block icon-trazado-1108 ml-auto mr-1" style="font-size:1.1em;"></i>
								<select
									@change="filtrarClasificacion"
									class="form-control form-control-sm my-1 mr-sm-2 input-select clasificacion-select"
									v-model="busqueda.parametros.codClasificacion"
								>
									<option value="0">Clasificación</option>
									<option
										:key="index"
										:value="c.codClasificacion"
										v-for="(c, index) in busqueda.resultados.clasificaciones"
									>{{ c.descripcion }}</option>
								</select>
							</div>
							<div class="col-11 col-md-4 offset-1 offset-md-0">
								<select
									@change="filtrarFormaFarmaceutica"
									class="form-control form-control-sm my-1 mr-sm-2 input-select forma-farmaceutica-select"
									v-model="busqueda.parametros.codFormaFarmaceutica"
								>
									<option value="0">Forma farmacéutica</option>
									<option
										:key="index"
										:value="f.codFormaFarmaceutica"
										v-for="(f, index) in busqueda.resultados.formasFarmaceuticas"
									>{{ f.descripcion }}</option>
								</select>
							</div>
							<div class="col-12 col-md-1 d-md-flex align-items-center justify-content-end d-none">
								<a
									@click="vistaTarjetas(true)"
									class="type-list text-decoration-none cursor-pointer"
									role="button"
									v-bind:class="{active: !modoGrid}"
									v-show="!modoGrid"
								>
									<div class="d-none d-flex flex-column align-items-center font-12">
										<i class="icon-grupo-4354 fa-lg"></i>
										<span class="font-13">Galería</span>
									</div>
								</a>
								<a
									@click="vistaTarjetas(false)"
									class="type-list text-decoration-none cursor-pointer"
									role="button"
									v-bind:class="{active: modoGrid}"
									v-show="modoGrid"
								>
									<div class="d-none d-flex flex-column align-items-center">
										<i class="icon-grupo-4356 fa-lg"></i>
										<span class="font-13">Listado</span>
									</div>
								</a>
							</div>
						</div>
					</div>
					<!-- Modo móvil -->
					<div class="d-xs-block d-sm-block d-md-none">
						<div class="row bg-gray">
							<div class="col-12 col-sm-12 mb-2 p-0">
								<nav aria-label="breadcrumb">
									<!-- <ol class="breadcrumb pl-0"> -->
										<!-- <ul> -->
											<li class="align-items-center justify-content-between breadcrumb-item">
												Captura de pedidos / Catálogo general 
												<button 
													@click="CambiarIcono" 
													id="btnCollapse" 
													
													class="btn btn-sm btn-blue-1"
												>
													<i v-b-toggle.collapse-1  v-if="down" class="fas fa-angle-up"></i>
													<i v-b-toggle.collapse-1  v-else class="fas fa-angle-down"></i>
												</button>
											</li>
											<!-- <li class="breadcrumb-item">Catálogo general</li> -->
											<!-- <button v-b-toggle.collapse-1 class="btn btn-sm btn-blue-1  ml-3"><i class="fas fa-ellipsis-v"></i></button> -->
											<b-collapse id="collapse-1">
												<div class="row">
													<div class="col-12 col-md-12" v-show="!busqueda.parametros.busquedaAvanzada">
														<button
															@click="mostrarBusquedaAvanzada(true)"
															class="btn btn-sm btn-blue-1 btn-block my-2 my-sm-0"
														>Búsqueda avanzada </button>
													</div>
													<div class="col-12 col-md-3 p-0 px-1">
														<div class="d-flex align-items-center">
															<div class="pr-1">
																<i class="icon-trazado-1107 filtro-fuente"></i>
															</div>
															<div class="flex-grow-1">
																<select
																	@change="ordenar"
																	class="form-control form-control-sm input-select"
																	v-model="busqueda.parametros.orden"
																>
																	<option value="0" hidden>Orden</option>
																	<option value="1">Alfabético</option>
																	<option value="2">Fórmula</option>
																	<option value="3">Precio Ascendente</option>
																	<option value="4">Precio Descendente</option>
																</select>
															</div>
														</div>
													</div>
													<div class="col-6 col-md-3 offset-md-1 p-0 pt-2 pt-md-0 pl-1 pl-md-0">
														<div class="d-flex align-items-center">
															<div class="pr-1">
																<i class="icon-trazado-1108 filtro-fuente"></i>
															</div>
															<div class="flex-grow-1">
																<select
																	@change="filtrarClasificacion"
																	class="form-control form-control-sm input-select"
																	v-model="busqueda.parametros.codClasificacion"
																>
																	<option value="0">Clasificacion</option>
																	<option
																		:key="index"
																		:value="c.codClasificacion"
																		v-for="(c, index) in busqueda.resultados.clasificaciones"
																	>{{ c.descripcion }}</option>
																</select>
															</div>
														</div>
													</div>
													<div class="col-6 col-md-3 p-0 pt-2 pt-md-0 px-1 pl-3">
														<select
															@change="filtrarFormaFarmaceutica"
															class="form-control form-control-sm input-select"
															v-model="busqueda.parametros.codFormaFarmaceutica"
														>
															<option value="0">Forma farmacéutica</option>
															<option
																:key="index"
																:value="f.codFormaFarmaceutica"
																v-for="(f, index) in busqueda.resultados.formasFarmaceuticas"
															>{{ f.descripcion }}</option>
														</select>
													</div>
												</div>
											</b-collapse>
										<!-- </ul> -->
									<!-- </ol> -->
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Termina barra de filtros resolución escritorio -->	

		<div class="alert alert-warning" v-if="(busqueda.resultados.resultadosPrincipales.length == 0 &&
												busqueda.resultados.resultadosSugeridos.length == 0)  && !loading">
			No se encontraron resultados para la busqueda "<b>{{ busqueda.parametros.buscar }}</b>"
		</div>	

		<!-- <div class="d-none d-md-block d-lg-block d-xl-block">
			<div class="mt-5"></div>
		</div> -->
		<!-- tarjetas de productos -->
		<div v-show="mostrarResultados">
			<div
				:class="[modoGrid ? '' : 'row']"
				class="grid mt-2 d-none d-md-block"
				horizontal-order="true"
				item-selector=".grid-item"
				transition-duration=".8s"
				v-masonry
			>
				<div
					:class="[modoGrid ? '' : 'col-12 col-xl-6 p-0']"
					:key="index"
					class="grid-item"
					v-for="(item, index) in busqueda.resultados.resultadosPrincipales"
					v-masonry-tile
				>
					<pm-card-producto
						:class="{'ml-xl-1': modoGrid ? true : index%2 != 0, 'mr-xl-1':  modoGrid ? true : index%2 == 0}"
						:item="item"
						:key="index"
						:modoTarjeta="modoGrid"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="my-1"
					></pm-card-producto>
				</div>
			</div>

			<div 
				class="d-none d-md-block alert alert-info mt-4" 
				v-show="busqueda.resultados.resultadosSugeridos.length > 0 && busqueda.resultados.resultadosPrincipales.length == 0"
			>
				No se encontraron resultados para la búsqueda "<b>{{ busqueda.parametros.buscar }}</b>", Podría interesarle los siguientes artículos
			</div>

			<div 
				class="alert alert-info mt-4" 
				v-show="busqueda.resultados.resultadosSugeridos.length > 0 && busqueda.resultados.resultadosPrincipales.length > 0"
			>
				Tambien podría interesarle los siguientes artículos
			</div>

			<div
				v-show="busqueda.resultados.resultadosSugeridos.length > 0"
				:class="[modoGrid ? '' : 'row']"
				class="grid mt-2 d-none d-md-block"
				horizontal-order="true"
				item-selector=".grid-item"
				transition-duration=".8s"
				v-masonry
			>
				
				<div
					:class="[modoGrid ? '' : 'col-12 col-xl-6 p-0']"
					:key="index"
					class="grid-item"
					v-for="(item, index) in busqueda.resultados.resultadosSugeridos"
					v-masonry-tile
				>
					<pm-card-producto
						:class="{'ml-xl-1': modoGrid ? true : index%2 != 0, 'mr-xl-1':  modoGrid ? true : index%2 == 0}"
						:item="item"
						:key="index"
						:modoTarjeta="modoGrid"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="my-1"
					></pm-card-producto>
				</div>
			</div>
			
			<div class="d-md-none d-flex flex-wrap justify-content-center">
				<div :key="index" v-for="(item, index) in busqueda.resultados.resultadosPrincipales">
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta="true"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="mx-2 my-1"
					></pm-card-producto>
				</div>
			</div>
			
			<div v-if="busqueda.resultados.resultadosSugeridos.length > 0" 
				class="mt-2 d-md-none d-flex flex-wrap justify-content-center">
				<div
					class="alert alert-info"
					v-show="busqueda.resultados.resultadosSugeridos.length > 0 && busqueda.resultados.resultadosPrincipales.length == 0"
				>
					No se encontraron resultados para la búsqueda "<b>{{ busqueda.parametros.buscar }}</b>", Podría interesarle los siguientes artículos
				</div>

				<div 
					class="alert alert-info"
					v-show="busqueda.resultados.resultadosSugeridos.length > 0 && busqueda.resultados.resultadosPrincipales.length > 0"
				>
					Tambien podría interesarle los siguientes artículos
				</div>
				
				<div :key="index" v-for="(item, index) in busqueda.resultados.resultadosSugeridos">
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta="true"
						@agregarCantidad="agregarCantidad"
						@mostrarDetalle="mostrarDetalle"
						class="mx-2 my-1"
					></pm-card-producto>
				</div>
			</div>

			
			<!-- Termina tarjetas de productos -->

			<!-- paginador -->
			<div class="row">				
				<div class="col-12 pt-3 d-flex justify-content-center">
					<ul class="pagination">
						<li class="page-item" v-show="busqueda.resultados.pagina > 1">
							<a @click="navegar(1)" class="page-link" role="button">«</a>
						</li>
						<li class="page-item">
							<a
								@click="navegar(busqueda.parametros.pagina-1)"
								class="page-link text-decoration-none"
								role="button"
								v-show="busqueda.resultados.pagina > 1 && 
								(busqueda.resultados.resultadosPrincipales != null && busqueda.resultados.resultadosSugeridos != null)"
							>Anterior</a>
						</li>
						<li :class="{active: busqueda.resultados.pagina == pag}" :key="pag" class="page-item" v-for="pag in paginas">
							<a @click="navegar(pag)" class="page-link">{{pag}}</a>
						</li>
						<li class="page-item" v-show="busqueda.resultados.pagina < busqueda.resultados.totalPaginas">
							<a @click="navegar(busqueda.parametros.pagina+1)" class="page-link" role="button">Siguiente</a>
						</li>
						<li class="page-item" v-show="busqueda.resultados.pagina < busqueda.resultados.totalPaginas">
							<a @click="navegar(busqueda.resultados.totalPaginas)" class="page-link" role="button">»</a>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<!-- ZONA DE SUGERIDOS -->

		<div v-if="busqueda.itemSeleccionadoBuscador">

			<div class="col-12 mb-3 mt-3" v-if="busqueda.itemsSustitutos.length > 0">
				<b-alert show variant="warning">
					<div class="col-12 titulo-sustitutos">Productos sugeridos</div>
				</b-alert>
			</div>

			<div class="col-12 pt-2" v-else>
				<b-alert
					show
					variant="warning"
				>No se encontraron sustitutos para el producto </b-alert>
			</div>

			<div class="row">

				<div
					:key="index"
					class="col-12 d-none d-lg-block"
					:class= "[modoGrid ? 'col-md-3 col-lg-3 col-xl-3 mb-2' : 'col-lg-6 col-xl-6 mb-2']"
					v-for="(item, index) in busqueda.itemsSustitutos"
				>
					<pm-card-producto
						:item="item"
						:key="index"
						:modoTarjeta= modoGrid
						@agregarCantidad="agregarCarritoTarjeta"
						@mostrarDetalle="detalleProductoRedirect"
					></pm-card-producto>
				</div>

			</div>

			<div class="row">

				<div 	:key="index"
						class="col-12 d-block d-lg-none"
						:class= "[modoGrid ? 'col-md-12' : 'col-md-12']"
						v-for="(item, index) in busqueda.itemsSustitutos"
				>
						<pm-card-producto
							:item="item"
							:key="index"
							:modoTarjeta= modoGrid
							@agregarCantidad="agregarCarritoTarjeta"
							@mostrarDetalle="detalleProductoRedirect"
						></pm-card-producto>
				</div>

			</div>

		</div>

	</div>
</template>

<script>
    import { mapActions, mapState, mapMutations } from 'vuex'	
	import PmCardProducto from "@/components/clientes/CardProducto"
	import servicio from "@/services/servicio-detalle-producto"
	
	export default {		
		data() {
			return {
				//codArticulo: 0,				
				listadoTipoGaleria: true,
                modoGrid: false,
				down: true,
				UUIDAcceso: ''
			}
        },
        async mounted(){                   
			this.busqueda.parametros = this.$route.query
			this.busqueda.parametros.pagina = parseInt(this.busqueda.parametros.pagina)
            this.busqueda.parametros.busquedaAvanzada = false
            this.buscarProductos()
            this.carritoConsultarCantidad()
            this.obtenerNotificaciones()
            this.vistaTarjetas(localStorage.getItem('modoGrid') == 'true' ? true : false)
			//console.log(this.modoGrid)
			this.CambiarIcono()
        },		
		components: {
			PmCardProducto,
        },
        updated(){            
            this.$nextTick(()=>{
                this.$redrawVueMasonry();
            })
        },
		methods: {            
			...mapMutations(['setParametros']),
            ...mapActions(['buscarProductos', 'resetParametros', 'resetResultados']),            
			async agregarCantidad(item) {

				if(item.tipoControl == 1 && item.cantidad > 0){
					this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
				}
				if(item.precioRemate > 0 && item.cantidad > 0){
					this.$msg.info( 'Producto de remate sin derecho a devolución.')
				}

				let token = ''
				if(window.localStorage.tokenDifarmer)
				{
					let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
					token = lstoken.token;
				}

				await this.validarClickPublicidad(item.codArticulo, token)

				this.carritoModificarCantidad(item.codArticulo, item.cantidad,this.UUIDAcceso)

			},
			async validarClickPublicidad(codArticulo, token){
				let r = await servicio.validarClickPublicidad({"idProducto":codArticulo, "accessToken":token} )
				if (r.data){
					this.UUIDAcceso = r.data[0]
				}
			},
			CambiarIcono(){
				if(this.down)
				{
					this.down = false;
				}
				else
				{
					this.down = true;
				}
			},
			mostrarDetalle(codArticulo) {
				this.$router.push({
					path: `/clientes/detalle-producto/${codArticulo}`,
				})
			},	
			filtrarClasificacion() {				
                this.busqueda.parametros.pagina = 1
                this.$router.replace({
					name: 'busqueda-general',
                    query: this.busqueda.parametros
                }) 
				this.buscarProductos()
			},
			filtrarFormaFarmaceutica() {				
                this.busqueda.parametros.pagina = 1
                this.$router.replace({
					name: 'busqueda-general',
                    query: this.busqueda.parametros
                }) 
				this.buscarProductos()
			},
			ordenar() {				
                this.busqueda.parametros.pagina = 1
                this.$router.replace({
					name: 'busqueda-general',
                    query: this.busqueda.parametros
                })                
                this.buscarProductos()
			},
			navegar(pag) {
				let q = {
					...this.busqueda.parametros,
					pagina : pag
				}
				this.setParametros(q)

				this.$router.replace({
					name: 'busqueda-general',
					query: q
				})
				
				this.buscarProductos()
				this.scrollToTop()				
			},
			scrollToTop() {
				window.scrollTo(0, 0);
			},
			mostrarBusquedaAvanzada() {
				//cambio para cuando se busque un articulo se lo lleve a busqueda avanzada, 
				//siempre y cuando no aya seleccionado ninguno de la lista cuando buscaba
				var busquedad = ""; 
				var Numpaso = 0;		
				if(!this.busqueda.itemSeleccionadoBuscador)
				{
					busquedad = this.busqueda.parametros.buscar;
					Numpaso = 2;
				}
				this.resetParametros()
                this.$router.push({
					name: 'busqueda-avanzada',
					query: { 
						...this.busqueda.parametros,
						busquedaAvanzada:true,
						generico: busquedad,
						tipoFormula: "A",
						paso: Numpaso,
					}
                })				
			},			
			vistaTarjetas(valor) {
				this.modoGrid = valor
				localStorage.setItem('modoGrid', valor)
				this.$nextTick(() => {
					if (typeof this.$redrawVueMasonry === "function") {
						this.$redrawVueMasonry()
					}
				})

				//console.log(this.modoGrid)
			},

			async agregarCarritoTarjeta(item) {
				if (item.cantidad && item.cantidad > 0) {
					if(item.tipoControl == 1){
						this.$msg.info( 'Producto refrigerado sin derecho a devolución.')
					}
					if(item.precioRemate > 0 && item.cantidad > 0){
						this.$msg.info( 'Producto de remate sin derecho a devolución.')
					}

					let token = ''
					if(window.localStorage.tokenDifarmer)
					{
						let lstoken = JSON.parse(window.localStorage.tokenDifarmer)
						token = lstoken.token;
					}

					await this.validarClickPublicidad(item.codArticulo, token)

					this.carritoModificarCantidad(item.codArticulo, item.cantidad, this.UUIDAcceso)
				}
			},
			detalleProductoRedirect(codArticulo) {
				try {
					this.codArticulo = codArticulo
					this.detalleProducto()
					this.$router
						.push({ path: `/clientes/detalle-producto/${codArticulo}` })
						.catch((err) => err)
					this.scrollMeTo('ancla')
				} catch {
					console.log("Error")
				}
			},
		},
		computed: {
            ...mapState(['busqueda', 'loading']),
			mostrarResultados() {
				if (this.busqueda.parametros.busquedaAvanzada && this.avanzada.paso < 4) return false

				return true
			},			
			paginas() {                
				const pagina = Number(this.busqueda.resultados.pagina)
				const totPaginas = Number(this.busqueda.resultados.totalPaginas)

				if (pagina == null || totPaginas == null) return []

				let res = []
				const max = 5
				let aux = Math.floor(max / 2)

				let inicio = pagina - aux > 0 ? pagina - aux : 1

				let fin = pagina + aux > totPaginas ? totPaginas : pagina + aux

				for (let i = inicio; i <= fin; i++) {
					res.push(i)
				}

				return res
			},
		},
	}
</script>
<style>

	bg-gris{
		background: #f4f4f4;
	}

	.posicion-menu{
		position: sticky;
		top: 60px;
		z-index: 100;
		border-radius: 10px;
	}

	/* .color-blaco{
		background: white; 
	} */

	.vr {
		width: 1px;
		height: 100%;
		border-left: 2px solid var(--bg-menu-blue) !important;
		margin: 2px 5px;
	}

	.btn-light.active {
		background-color: var(--bg-menu-blue) !important;
		color: #fff !important;
	}

	.img-forma-farma {
		margin: 0 0.5rem;
		cursor: pointer;
		padding: 3px;
	}

	/* .img-forma-farma:hover {
		background-color: var(--bg-menu-blue);
		border-radius: 8px;
	}

	.img-forma-farma.active {
		background-color: var(--bg-menu-blue);
		border-radius: 8px;
	} */

	.titulo-busqueda {
		color: var(--bg-menu-blue) !important;
		font-size: 14px;
		font-weight: bold;
	}

	.type-list {
		color: var(--bg-gray);
		font-size: 14px;
	}

	.type-list.active {
		color: var(--bg-menu-blue) !important;
	}

	.breadcrumb-item {
		font-size: 13px;
		font-weight: bold;
		color: var(--color-font-breadcum);
	}

	.bg-filtro {
		background-color: #ffffff;
		color: var(--bg-menu-blue);
		font-size: 14px;
	}

	.input-select {
		border-color: var(--bg-menu-blue);
		color: var(--bg-menu-blue);
		/*max-width: 170px;*/
	}

	.pagination .page-item {
		margin: 0 0.4rem !important;
		border: none !important;
		background-color: #ffffff;
		border-radius: 100%;
	}
	.page-item a {
		text-decoration: none !important;
		color: var(--bg-menu-blue) !important;
	}

	.page-item.active a {
		color: #fff !important;
	}

	.page-link {
		cursor: pointer;
	}

	.btn-blue {
		background-color: var(--bg-menu-blue) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 11px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 11px;
		}
		.input-select {
			font-size: 11px;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 12px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 12px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 14px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 14px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		/* Encabezado */
		.breadcrumb-item {
			font-size: 14px;
		}
		/* Filtro */
		.filtro-fuente {
			font-size: 14px;
		}
		.input-select {
			font-size: 12px;
		}
	}

</style>
